import styled from 'styled-components'
import BackgroundImg from '../../../assets/images/background.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.625rem;
  height: 100vh;
  overflow-y: auto;
  background-color: #EBEBEB;
  background-image: url(${BackgroundImg});
  background-position: right bottom;
  background-repeat: no-repeat;
  background-size: 100vh;
  position: relative;
`

export const Header = styled.header`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.375rem;

  margin-top: 1.625rem;
  width: 100%;
  height: 5.8125rem;

  @media (max-width: 800px)
  {
    height: 3.8125rem;
  }

  @media screen and (max-width: 375px),
                    (max-height: 720px)
  {
    gap: 0px;
    margin-bottom: 5rem;
  }

`

export const MainTitle = styled.h1`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 1.2rem;
  color: #4A2CD3;

`

export const MainSubTitle = styled.strong`
  font-family: 'Nunito Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 1.03rem;
  color: #485465;
`

export const SuccessMain = styled.main`
  padding: 2rem;
  background: #FFFFFF;
  border: 1px solid #EFF2F7;
  box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.02);
  border-radius: 7px;
`

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 1.25rem 1.2rem 0px;
  gap: 1.3125rem;
`

export const SuccessTitle = styled(MainTitle)`
  font-size: 1.6875;
  text-align: center;
`

export const SucessSubTitle = styled(MainSubTitle)`
  text-align: center;
`